const tableSchemaBase = [
	{
		accessor: 'site',
		title: 'global.site',
		sortable: true,
	},
	{
		accessor: 'startDate',
		title: 'global.startDate',
	},
	{
		accessor: 'production',
		title: 'global.quantity',
	},
	{
		accessor: 'tokenEquivalent',
		title: 'global.tokenEquivalent',
	},
	{
		type: 'productionsStartMintWithoutRemoveActions',
		accessor: '',
		width: 50,
		resizable: true,
	},
];

export { tableSchemaBase };
